import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconKeyboardDoubleArrowRightSvg } from "./IconKeyboardDoubleArrowRightSvg.mjs";
const IconKeyboardDoubleArrowRight = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconKeyboardDoubleArrowRightSvg, ...iconProps });
};
export {
  IconKeyboardDoubleArrowRight
};
